<template>
    <v-container>
          <v-layout row wrap>
            <v-flex class="mr-1 mt-1" xs12 sm6 md3  v-for="item in actions" :key="item.action">
                <v-card>
                  <v-card-title>{{ item.name}}</v-card-title>
                  <v-card-text>{{ item.description }}</v-card-text>
                  <v-card-actions>
                    <v-btn
                      :to="{path: `/adoptions/report/${item.action}`}"
                    >Vai
                    </v-btn>
                  </v-card-actions>
                </v-card>
            </v-flex>
          </v-layout>
    </v-container>
</template>
<script>
import { routeNames } from '../../config/router/routeNames';

export default {
  name: 'AdoptionReport',
  data() {
    return {
      actions: [
        /*
        {
          name: 'EDITORE',
          action: routeNames.ADOPTION_REPORT_EDITOR,
          description: 'il totale dei libri adottati per editore',
        },
        */

        {
          name: 'EDITORE PROPAGANDISTA ',
          action: routeNames.ADOPTION_REPORT_EDITOR_PROPAGANDIST,
          description: 'il totale dei libri adottati per propagandista e editore',
        },
        /*

        {
          name: 'EDITORE SCUOLA',
          action: routeNames.ADOPTION_REPORT_EDITOR_SCHOOL,
          description: 'il totale dei libri adottati per editore e scuola',
        },
        */
        {
          name: 'LIBRO PROPAGANDISTA',
          action: routeNames.ADOPTION_REPORT_PROPAGANDIST_BOOK,
          description: 'il totale dei libri adottati per propagandista e libro',
        },

        {
          name: 'LIBRO SCUOLA',
          action: routeNames.ADOPTION_REPORT_BOOK_SCHOOL,
          description: 'il totale dei libri adottati per scuola',
        },
/*
        {
          name: 'PROPAGANDISTA',
          action: routeNames.ADOPTION_REPORT_PROPAGANDIST,
          description: 'il totale dei libri adottati per propagandista',
        },

        {
          name: 'PROPAGANDISTA EDITORE',
          action: routeNames.ADOPTION_REPORT_PROPAGANDIST_EDITOR,
          description: '',
        },
*/
        {
          name: 'PROPAGANDISTA SCUOLA',
          action: routeNames.ADOPTION_REPORT_PROPAGANDIST_SCHOOL,
          description: 'il totale di quante adozioni ha ogni propagandista in ogni scuola',
        },
        /*
        {
          name: 'SCUOLA',
          action: routeNames.ADOPTION_REPORT_SCHOOL,
          description: 'il totale dei libri adottati per scuola',
        },
        */

        {
          name: 'SCUOLA',
          action: routeNames.ADOPTION_REPORT_TOTAL_SCHOOL,
          description: 'il totale dei libri adottati per scuola',
        },

      ],
    };
  },
};
</script>
